import actionConstants from '../constants/';

const defaultAsyncState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: null,
  errorMessage: '',
};

const initialState = {
  getChildren: { ...defaultAsyncState },
  updateChild: { ...defaultAsyncState },
  getAudit: { ...defaultAsyncState },
};

const splitSettlementReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.GET_SPLIT_SETTLEMENT_CHILDREN_REQUEST:
      return { ...state, getChildren: { ...defaultAsyncState, isLoading: true } };
    case actionConstants.GET_SPLIT_SETTLEMENT_CHILDREN_SUCCESS:
      return { ...state, getChildren: { ...defaultAsyncState, isSuccess: true, data: action.payload.body } };
    case actionConstants.GET_SPLIT_SETTLEMENT_CHILDREN_FAILURE:
      return { ...state, getChildren: { ...defaultAsyncState, isFailure: true, errorMessage: action.payload?.body?.message } };
    case actionConstants.GET_SPLIT_SETTLEMENT_CHILDREN_CLEAR:
      return { ...state, getChildren: { ...defaultAsyncState } };

    case actionConstants.UPDATE_SPLIT_SETTLEMENT_CHILD_REQUEST:
      return { ...state, updateChild: { ...defaultAsyncState, isLoading: true } };
    case actionConstants.UPDATE_SPLIT_SETTLEMENT_CHILD_SUCCESS:
      return { ...state, updateChild: { ...defaultAsyncState, isSuccess: true, data: action.payload.body } };
    case actionConstants.UPDATE_SPLIT_SETTLEMENT_CHILD_FAILURE:
      return { ...state, updateChild: { ...defaultAsyncState, isFailure: true, errorMessage: action.payload?.body?.message } };
    case actionConstants.UPDATE_SPLIT_SETTLEMENT_CHILD_CLEAR:
      return { ...state, updateChild: { ...defaultAsyncState } };

    case actionConstants.GET_SPLIT_SETTLEMENT_AUDIT_REQUEST:
      return { ...state, getAudit: { ...defaultAsyncState, isLoading: true } };
    case actionConstants.GET_SPLIT_SETTLEMENT_AUDIT_SUCCESS:
      return { ...state, getAudit: { ...defaultAsyncState, isSuccess: true, data: action.payload.body } };
    case actionConstants.GET_SPLIT_SETTLEMENT_AUDIT_FAILURE:
      return { ...state, getAudit: { ...defaultAsyncState, isFailure: true, errorMessage: action.payload?.body?.message } };
    case actionConstants.GET_SPLIT_SETTLEMENT_AUDIT_CLEAR:
      return { ...state, getAudit: { ...defaultAsyncState } };

    default:
      return state;
  }
};

export default splitSettlementReducer;
